import { render, staticRenderFns } from "./spt.vue?vue&type=template&id=560f80c2"
import script from "./spt.vue?vue&type=script&lang=js"
export * from "./spt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports